import {useRef} from "react";

const useOnce = <T extends any>(value: T): T => {
    const onceValue = useRef<T>(value)
    return onceValue.current;
}

export default useOnce;